import { createFileRoute } from '@tanstack/react-router';

import { WgComposeBriefDtoSectionCategory } from 'src/apis/backend/generated/models';

import { SectionRequestView } from 'src/sections/white-glove/section/section-request-view';

/**
 * Asking us to build the brand's header.
 *
 * The footer page's twin at the other end of the email, and for the same
 * reason not a mode of the calendar: the header lands in the brand's library
 * and every email built afterwards opens on it, so there is nothing to date.
 * A path of its own rather than a query on the footer's, so a link to either
 * says which one it means and the footer's address keeps working as it was.
 */
export const Route = createFileRoute('/_authed/dashboard/o/$orgId/c/$clientId/white-glove/header')({
  component: WgHeaderPage,
});

function WgHeaderPage() {
  return <SectionRequestView category={WgComposeBriefDtoSectionCategory.header} />;
}
